module.exports = __webpack_public_path__ + "static/media/AI_Track_Icon.8c047611.svg";